export const config = {
  app: "catexpert",
  appTitle: "CatExpert.ai - AI Enabled Self-Service Retail Optimizer",
  appFavicon: "https://cdn.catexpert.ab-inbev.com/assets/images/favicon.ico",
  supportMailID: "catexpert.team@ab-inbev.com",
};
